import React, { Children, cloneElement } from 'react';

import { Box } from '..';
import { ComponentProps } from '../utils/types';
import {
  StyledDate,
  StyledDescription,
  StyledIconContainer,
  StyledItemContainer,
  StyledLine,
  StyledListItem,
  StyledTitle
} from './styles';
import { TimelineItemProps as TimelineItemPropsInterface } from './types';

const TimelineItem = React.forwardRef<
  HTMLLIElement,
  TimelineItemPropsInterface
>(
  (
    {
      title,
      icon,
      description,
      date,
      status = 'COMPLETED',
      order = 0,
      subItem = false,
      children,
      childrenId,
      ...rest
    },
    ref
  ) => {
    return (
      <StyledListItem subItem={subItem} ref={ref} {...rest}>
        <StyledItemContainer subItem={subItem}>
          <StyledLine status={status} order={order} />
          <StyledIconContainer status={status} order={order} subItem={subItem}>
            {icon}
          </StyledIconContainer>
          <Box flexGrow={1}>
            <StyledTitle status={status} subItem={subItem}>
              {title}
            </StyledTitle>
            {date && <StyledDate status={status}>{date}</StyledDate>}
            {description && (
              <StyledDescription status={status}>
                {description}
              </StyledDescription>
            )}
          </Box>
        </StyledItemContainer>
        {children && (
          <ol style={{ margin: 0, padding: 0 }} id={childrenId}>
            {Children.map(children, (child, index) => {
              if (!React.isValidElement(child)) return null;
              return cloneElement(child, {
                order: order + (index + 1) / 100,
                subItem: true
              });
            })}
          </ol>
        )}
      </StyledListItem>
    );
  }
);

export type TimelineItemProps = ComponentProps<typeof TimelineItem>;
export default TimelineItem;
